import {combine, merge, sample} from 'effector';

import {RestError, showRestError} from 'core/errors';

import {
    organizationList$,
    fetchDataFx,
    filters$,
    filtersChanged,
    Gate,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
    organizationBalanceChanged,
} from './index';

organizationList$
    .on(fetchDataFx.doneData, (_, data) => data)
    .on(organizationBalanceChanged, (state, {currentBalance, legalIdentityId}) => {
        if (!state) return state;
        return {
            ...state,
            data: state.data.map((org) =>
                org.id === legalIdentityId ? {...org, balance: currentBalance} : org,
            ),
        };
    })
    .reset(Gate.close);
filters$.reset(Gate.close);
pageNumber$.reset(Gate.close);
pageSize$.reset(Gate.close);

sample({
    clock: merge([Gate.open, pageNumberChanged, pageSizeChanged, filtersChanged]),
    source: combine({
        filters: filters$,
        pageNumber: pageNumber$,
        pageSize: pageSize$,
    }),
    fn: ({filters, pageNumber, pageSize}) => {
        const taxIdNumber = filters.find(({id}) => id === 'taxIdNumber')?.value;

        return {
            paging: {
                pageNumber,
                pageSize,
            },
            filters: [],
            sortings: [],
            taxIdNumber: typeof taxIdNumber === 'string' ? taxIdNumber.trim() : undefined,
        };
    },
    target: fetchDataFx,
});

fetchDataFx.fail.watch(({error}) => showRestError(error as RestError));
